export default "/images/5449b75949838981a70ac2ef41b483f5.avif";